import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from 'react-query';
import { Scaffold } from 'layouts';
import { FormPageHeader } from 'components/Shared';
import { CreationForm } from 'components/Pages/ChecklistTemplates';
import { useChecklistTemplates } from 'hooks/api/useChecklistTemplates';
import { useToast } from 'components/ui/use-toast';
import * as S from './styles';

export const ChecklistTemplateCreationPage: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { createChecklistTemplate } = useChecklistTemplates();

  const createMutation = useMutation(createChecklistTemplate, {
    onSuccess: () => {
      toast({
        title: 'Sucesso',
        description: 'Checklist cadastrado com sucesso',
        duration: 5000,
      });
      navigate('/configuracoes/checklist/modelos');
    },
    onError: (error: any) => {
      toast({
        variant: 'destructive',
        title: 'Erro',
        description:
          error?.response?.data?.message || 'Erro ao cadastrar checklist',
        duration: 5000,
      });
    },
  });

  const onSubmit = useCallback(
    async (data: { name: string; google_id: string; slug: string }) => {
      await createMutation.mutateAsync(data);
    },
    [createMutation]
  );

  return (
    <Scaffold>
      <S.PageContainer>
        <S.MainPanel>
          <FormPageHeader
            title="Novo modelo de checklist"
            icon={<S.BookContentIcon />}
            actions={
              <S.LinkButton
                size="small"
                to="/configuracoes/checklist/modelos"
              >
                <S.ArrowLeftIcon /> Voltar
              </S.LinkButton>
            }
          />
          <CreationForm
            loading={createMutation.isLoading}
            onSubmit={onSubmit}
          />
        </S.MainPanel>
      </S.PageContainer>
    </Scaffold>
  );
};
